<template>
  <!-- Dont delete the `v-elemint-value` directive, otherwise the fusion check only get the value `on` or `off` -->
  <div
    v-element-value="_value"
    class="hkl-radio-button"
  >
    <input
      type="radio"
      :checked="checked"
      v-bind="$attrs"
      @change="change"
      v-on="$listeners"
    >
    <div
      v-if="$slots.default"
      class="hkl-radio-button__slot"
      @click="() => !$attrs.disabled && change()"
    >
      <slot />
    </div>
  </div>
</template>
<script>
import { computed, unref } from 'vue-demi'

const SOURCE = '_value'
const EVENT = '_select'

export default {
  name: 'HKLRadioButton',
  model: {
    prop: SOURCE,
    event: EVENT,
  },
  props: ['value', SOURCE],
  setup (props, { emit }) {
    const currentValue = computed(() => props[SOURCE])
    const targetValue = computed(() => props.value)
    return {
      checked: computed(() => typeof unref(currentValue) !== 'undefined' && unref(currentValue) === unref(targetValue)),
      change: () => emit(EVENT, unref(targetValue)),
    }
  },
}
</script>

<style lang="scss" scoped>
$buttonHeight: 18px;

.hkl-radio-button {
  display: flex;
  flex-direction: row;

  input {
    margin: 0;
    height: $buttonHeight;
    width: 18px;
    &:not([disabled]) {
      cursor: pointer;
    }

    & + * {
      margin-left: 5px;
      line-height: $buttonHeight;
    }
    &:not([disabled]) + * {
      cursor: pointer;
    }
  }
}
</style>
